export default __webpack_public_path__ + "static/media/Icons_Calendar Icon.1781436f.svg";